import { supabase } from '@fd/supabase/index';
import useSWR from 'swr';

export default function useAccount() {
  const { data } = useSWR('account', async () => {
    if((await supabase.auth.getSession()).data.session)
      return (await supabase.from('user_account').select().single()).data;
    return undefined;
  });
  return data;
}
